import groupResponsibleAPIClient from '@/scopes/account/group-responsible/infrastructure/groupResponsibleAPIClient';
import * as React from 'react';
import { groupResponsibleStore } from '../infrastructure/store';

interface GroupResponsibleDependencies {
  groupResponsibleAPIClient: typeof groupResponsibleAPIClient;
  groupResponsibleStore: typeof groupResponsibleStore;
}

const defaultDependencies: GroupResponsibleDependencies = {
  groupResponsibleAPIClient,
  groupResponsibleStore,
};

const GroupResponsibleDependenciesContext = React.createContext<GroupResponsibleDependencies>(defaultDependencies);

export const GroupResponsibleDependenciesProvider = ({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: GroupResponsibleDependencies }>) => {
  return (
    <GroupResponsibleDependenciesContext.Provider value={dependencies}>
      {children}
    </GroupResponsibleDependenciesContext.Provider>
  );
};

export const useGroupResponsibleDependencies = () => {
  return React.useContext(GroupResponsibleDependenciesContext);
};
